import React from 'react';
import { motion } from 'framer-motion';
interface SwimmingFishProps {
  delay?: number;
  duration?: number;
  yRange?: [number, number];
  scale?: number;
  color?: string;
  direction?: 'left' | 'right';
  className?: string;
}
export function SwimmingFish({
  delay = 0,
  duration = 15,
  yRange = [-20, 20],
  scale = 1,
  color = '#4fd1c5',
  direction = 'right',
  className = ''
}: SwimmingFishProps) {
  return <motion.div className={`absolute pointer-events-none ${className}`} initial={{
    x: direction === 'right' ? '-20vw' : '120vw',
    y: 0,
    scaleX: direction === 'right' ? 1 : -1,
    scale: scale
  }} animate={{
    x: direction === 'right' ? '120vw' : '-20vw',
    y: yRange,
    rotate: [0, 5, -5, 0]
  }} transition={{
    x: {
      duration: duration,
      repeat: Infinity,
      ease: 'linear',
      delay: delay
    },
    y: {
      duration: 4,
      repeat: Infinity,
      repeatType: 'mirror',
      ease: 'easeInOut'
    },
    rotate: {
      duration: 2,
      repeat: Infinity,
      repeatType: 'mirror',
      ease: 'easeInOut'
    }
  }} data-id="element-6">
      <svg width="60" height="40" viewBox="0 0 60 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-7">
        <path d="M58 20C58 20 45 0 30 0C15 0 10 10 0 20C10 30 15 40 30 40C45 40 58 20 58 20Z" fill={color} fillOpacity="0.8" data-id="element-8" />
        <circle cx="45" cy="15" r="3" fill="white" data-id="element-9" />
        <path d="M35 20C35 20 25 25 25 20C25 15 35 20 35 20Z" fill="rgba(0,0,0,0.2)" data-id="element-10" />
        <path d="M58 20L60 15M58 20L60 25" stroke={color} strokeWidth="2" strokeLinecap="round" data-id="element-11" />
      </svg>
    </motion.div>;
}